import { Box, Flex, Image, Link, useDisclosure, IconButton, VStack, useBreakpointValue } from "@chakra-ui/react";
import styles from "../Style/Style.module.css";
import { useState, useEffect } from 'react';
import { LoginButtonWithDropdown } from "./LoginButtonWithDropdown.component";
import { wordpressBaseUrl } from "../../../wordpressApiConfig/wordpressApiConfig";
import { getObjectUrlFromBlob } from "../../../GlobalActions/getImageFromBlob";
import { getImageBaseUrl } from "../../../Helper/env";


export const Navbar = () => {
    const [isScrolled, setIsScrolled] = useState(false);
    const [logoUrl, setLogoUrl] = useState<string>("");
    const { isOpen, onToggle } = useDisclosure();
    const wpBaseUrl = wordpressBaseUrl();
    // Determine if we're in mobile view
    const isMobile = useBreakpointValue({ base: true, lg: false });

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 10) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    useEffect(() => {
        const loadLogo = async () => {
            try {
                const url = await getObjectUrlFromBlob(`${getImageBaseUrl()}/azure/api/v1/signedUrl/get-public-document/logos/pococare-logo.png`);
                setLogoUrl(url);
            } catch (error) {
                console.error('Error loading logo:', error);
                // Fallback to a default logo or empty string
                setLogoUrl('/Images/poco-care-text-logo.png'); // or setLogoUrl('');
            }
        };
        loadLogo();
    }, []);

    const navLinks = [
        { text: "About Us", href: `${wpBaseUrl}/about-us/` },
        { text: "Request a demo", href: `${wpBaseUrl}/contact-us/` },
        { text: "Buy Subscription", href: `${wpBaseUrl}/b2c/` },
        { text: "Career", href: `${wpBaseUrl}/why-pococare/` },
        { text: "Blog", href: `${wpBaseUrl}/blog/` },
    ];

    return (
        <Box
            position="fixed"
            top="0"
            left="0"
            right="0"
            zIndex="1000"
            bg="white"
            transition="all 0.5s ease"
            height={isMobile ? (isScrolled ? "66.25px" : "84.26px") : (isScrolled ? "86.25px" : "132.387px")}
            boxShadow={isScrolled ? "md" : "none"}
            maxWidth="100%"
        >
            <Flex
                flexDirection={"row"}
                justifyContent={"space-between"}
                alignItems="center"
                height="100%"
                maxWidth="100%"
                paddingX={{ base: "15px", md: "40px" }}
                paddingY={"10px"}
            >
                <Box
                    transition="all 0.5s ease"
                    width={isScrolled ? "150px" : isMobile ? "160px" : "234px"}
                    onClick={() => window.open(`${wpBaseUrl}/home/`, "_self")}
                    sx={{ cursor: "pointer" }}
                >
                    <Image
                        src={logoUrl}
                        width={"100%"}
                        height={"100%"}
                        objectFit="contain"
                        alt="Company Logo"
                        sx={{ pointerEvents: "none" }}
                    />
                </Box>
               


                {!isMobile ? (
                    <Flex
                        justifyContent={"space-between"}
                        alignItems={"center"}
                        gap={"61.6px"}
                        boxSizing="border-box"
                        paddingRight={"10px"}
                    >
                        {navLinks.map((link) => (
                            <Link
                                key={link.text}
                                href={link.href}
                                className={styles.navTextStyle}
                                _hover={{ color: "red" }}
                            >
                                {link.text}
                            </Link>
                        ))}
                        <LoginButtonWithDropdown />
                    </Flex>
                ) : (
                    <>
                        <IconButton
                            onClick={onToggle}
                            icon={isOpen ? <CustomClose /> : <CustomHamburger />}
                            variant={"ghost"}
                            aria-label={"Toggle Navigation"}
                            color="red.500"
                        />
                    </>
                )}
            </Flex>

            {/* Mobile menu */}
            {isMobile && isOpen && (
                <Box
                    bg="white"
                    px={4}
                    pb={4}
                    boxShadow="md"
                >
                    <VStack as={"nav"} spacing={1} padding={"15px"}>
                        {navLinks.map((link) => (
                            <Link
                                key={link.text}
                                href={link.href}
                                className={styles.navTextStyle}
                                _hover={{ color: "red" }}
                                w="full"
                                textAlign="left"
                                py={2}
                                borderBottom="0.5px ridge"
                                borderBottomColor="rgba(0, 0, 0, 0.2)"
                                padding={"15px"}
                                letterSpacing={"0px"}
                                fontFamily={"Poppins, sans-serif"}
                            >
                                {link.text}
                            </Link>
                        ))}
                        <Box w="full" textAlign="center" py={2}>
                            <LoginButtonWithDropdown />
                        </Box>
                    </VStack>
                </Box>
            )}
        </Box>
    );
}

const CustomHamburger = () => (
    <svg width="27" height="27" viewBox="0 0 25 25">
        <path
            fill="currentColor"
            stroke="currentColor"
            strokeWidth="3" // Makes lines thicker
            strokeLinecap="round"
            d="M4 6h16M4 12h16M4 18h16"
        />
    </svg>
);

const CustomClose = () => (
    <svg width="27" height="27" viewBox="0 0 25 25">
        <rect
            x="3" y="3"
            width="18" height="18"
            rx="2"
            fill="none"
            stroke="red"
            strokeWidth="2"
        />
        <path
            stroke="red"
            strokeWidth="2"
            strokeLinecap="round"
            d="M8 8l8 8M16 8l-8 8"
        />
    </svg>
);